<template>
  <div id="app">
    <div class="page_a">
      <router-view></router-view>
    </div>
    <div class="page_b">
      <router-view name="pageTwo"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {}
}
</script>

<style>
.page_a {
  background-color: #f2f6fa;
}
.page_b {
  background: #f7f5f0;
}
</style>
